/*
  ADA / WCAG 2.2.2 + 2.3.3 (2026-09-23): when the visitor's OS asks for reduced
  motion, stop Flickity auto-advancing sliders and autoplaying <video> elements.
  Nothing changes for anyone else. Sliders stay fully usable (arrows/dots/drag),
  videos keep their controls where they have them. The scroll-reveal animations
  are already gated in CSS (base.css.liquid) and animations.js.
*/
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mq.matches) return;

  function stopFlickity(el) {
    try {
      var f = window.Flickity && window.Flickity.data(el);
      if (!f) return;
      if (f.options && f.options.autoPlay) {
        f.options.autoPlay = false; // prevents a restart on resize/re-activate
        if (typeof f.stopPlayer === 'function') f.stopPlayer();
      }
    } catch (e) {}
  }
  function stopVideo(v) {
    try {
      if (v.hasAttribute('autoplay') || v.autoplay) {
        v.autoplay = false;
        v.removeAttribute('autoplay');
        v.pause();
        v.setAttribute('data-reduced-motion-paused', '');
      }
    } catch (e) {}
  }
  function sweep() {
    document.querySelectorAll('.flickity-enabled').forEach(stopFlickity);
    document.querySelectorAll('video').forEach(stopVideo);
  }
  var pending = null;
  function sweepSoon() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; sweep(); }, 250);
  }
  document.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('load', sweep);
  setTimeout(sweep, 1500);
  setTimeout(sweep, 4000);
  // Flickity instances and JS-built videos appear late (deferred scripts, lazy sections)
  if (window.MutationObserver) {
    new MutationObserver(sweepSoon).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'autoplay']
    });
  }
  // a video that starts anyway (e.g. programmatic play()) gets paused once
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (v && v.tagName === 'VIDEO' && !v.hasAttribute('data-user-played')) {
      if (v.hasAttribute('data-reduced-motion-paused')) { v.pause(); }
    }
  }, true);
  document.addEventListener('click', function (e) {
    var v = e.target && e.target.closest && e.target.closest('video');
    if (v) v.setAttribute('data-user-played', '');
  }, true);
})();
